import { before } from "lodash";
import canAccessGuard from "../guards/canAccessGuard";

export default [
  // Custom Reports
  {
    name: 'custom-report-builder',
    path: '/reports/builder',
    component: () => import('@views/reports/builder/CustomReportBuilder.vue'),
    meta: { requiresAuth: true }
  },
  {
    name: 'saved-reports',
    path: '/reports/saved',
    component: () => import('@views/reports/builder/SavedReportsList.vue'),
    meta: { requiresAuth: true }
  },
  // {
  //     name: 'dashboard',
  //     path: '/',
  //     component: () =>
  //         import( /* webpackChunkName: "chunks/dashboard" */ '@views/Dashboard'),
  //     meta: {
  //         requiresAuth: true
  //     }
  // },
  {
    name: "seeder-manager",
    path: "/system-seeder",
    component: () =>
      import(
        /* webpackChunkName: "chunks/system" */ "@views/system/SeederManager"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "dashboard",
    path: "/",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/AdminDashboard"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "school-profile",
    path: "/school-profile",
    component: () =>
      import(
        /* webpackChunkName: "chunks/schools" */ "@views/schools/SchoolProfile"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "school-online-hours",
    path: "/school-online-hours",
    component: () =>
      import(
        /* webpackChunkName: "chunks/schools" */ "@views/schools/SchoolOnlineHours"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("edit_school_online_hours"),
  },
  {
    name: "detailed-total",
    path: "/detailed-total",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/total_revenue/StudentList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_detailed_total_of_revenue_types"),
  },
  {
    name: "zatika-settings",
    path: "/zatika-settings",
    component: () =>
      import(
        /* webpackChunkName: "chunks/schools" */ "@views/zatika/ZatikaProfile"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "general-zatca-settings",
    path: "/general-zatca-settings",
    component: () =>
      import(
        /* webpackChunkName: "chunks/schools" */ "@views/zatca_general_settings/Settings"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("zatka_settings_zatca_settings_zatca_school_settings"),
  },
  {
    name: "tax-settings",
    path: "/tax-settings",
    component: () =>
      import(
        /* webpackChunkName: "chunks/tax-settings" */ "@views/tax_settings/TaxList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_tax_management"),
  },
  {
    name: "edit-roles",
    path: "/roles/edit/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/roles" */ "@views/roles/NewRoleForms"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("edit_roles"),
  },


  {
    name: "courses",
    path: "/courses",
    component: () =>
      import(
        /* webpackChunkName: "chunks/courses" */ "@views/courses/CoursesList"
      ),
    meta: {
      requiresAuth: true,
    },
  },

  {
    name: "subjects",
    path: "/subjects",
    component: () =>
      import(
        /* webpackChunkName: "chunks/subjects" */ "@views/subjects/SubjectsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_subject"),
  },


  {
    name: "scheduling-calendar",
    path: "/scheduling-calendar",
    component: () =>
      import(
        /* webpackChunkName: "chunks/scheduling-calendar" */ "@views/scheduling_calendar/Calendar"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("save_scheduling_calendar"),
  },
  {
    name: "academic-years",
    path: "/academic-years",
    component: () =>
      import(
        /* webpackChunkName: "chunks/academic-years" */ "@views/academic_years/AcademicYearsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "stages",
    path: "/stages",
    component: () =>
      import(
        /* webpackChunkName: "chunks/stages" */ "@views/stages/StagesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_stage"),
  },
  {
    name: "year-levels",
    path: "/year-levels",
    component: () =>
      import(
        /* webpackChunkName: "chunks/year-levels" */ "@views/year_levels/YearLevelsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_year_level"),
  },
  {
    name: "classes",
    path: "/classes",
    component: () =>
      import(
        /* webpackChunkName: "chunks/classes" */ "@views/classes/ClassesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_class_model"),
  },
  {
    name: "assign-students",
    path: "/assign-students",
    component: () =>
      import(
        /* webpackChunkName: "chunks/assign-students" */ "@views/subjects/AssignStudentsForm"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("edit_classroom_assignment"),
  },
  {
    name: "classrooms",
    path: "/classrooms",
    component: () =>
      import(
        /* webpackChunkName: "chunks/classrooms" */ "@views/classrooms/ClassroomsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_classroom"),
  },
  {
    name: "teachers",
    path: "/teachers",
    component: () =>
      import(
        /* webpackChunkName: "chunks/teachers" */ "@views/teachers/TeachersList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_teacher"),
  },
  {
    name: "buildings",
    path: "/buildings",
    component: () =>
      import(
        /* webpackChunkName: "chunks/buildings" */ "@views/buildings/BuildingList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_building"),
  },

  {
    name: "students",
    path: "/students",
    component: () =>
      import(
        /* webpackChunkName: "chunks/students" */ "@views/students/StudentsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "students-groups",
    path: "/students-groups",
    component: () =>
      import(
        /* webpackChunkName: "chunks/students-groups" */ "@views/students_groups/StudentsGroupsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_students_group"),
  },
  {
    name: "families",
    path: "/families",
    component: () =>
      import(
        /* webpackChunkName: "chunks/families" */ "@views/families/FamiliesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_families"),
  },

  {
    name: "families-transactions",
    path: "/families-transactions",
    component: () =>
      import(
        /* webpackChunkName: "chunks/families" */ "@views/families/FamiliesTransactionsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("access_family_financial_transaction"),
  },
  {
    name: "families-create",
    path: "/families/create",
    component: () =>
      import(
        /* webpackChunkName: "chunks/families" */ "@views/families/FamilyForm copy"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "families-edit",
    path: "/families/edit/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/families" */ "@views/families/FamilyForm copy"
      ),
    meta: {
      requiresAuth: true,
    },
  },

  {
    // for financial module
    name: "financial-families",
    path: "/financial/families",
    component: () =>
      import(
        /* webpackChunkName: "chunks/families" */ "@views/families/FamiliesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("access_family_financial_transaction"),
  },

  {
    name: "students-print",
    path: "/students-print",
    component: () =>
      import(
        /* webpackChunkName: "chunks/students" */ "@views/students/printList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("print_parents_codes_father"),
  },

  {
    name: "time-tables",
    path: "/time-tables",
    component: () =>
      import(
        /* webpackChunkName: "chunks/time-tables" */ "@views/time_tables/TimeTablesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_time_table"),
  },
  {
    name: "worksheets",
    path: "/worksheets",
    component: () =>
      import(
        /* webpackChunkName: "chunks/worksheets" */ "@views/worksheets/WorksheetsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "albums",
    path: "/albums",
    component: () =>
      import(
        /* webpackChunkName: "chunks/albums" */ "@views/albums/AlbumsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "reports",
    path: "/scheduling-reports",
    component: () =>
      import(
        /* webpackChunkName: "chunks/scheduling-reports" */ "@views/scheduling_reports/Reports"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_time_table_reports"),
  },
  {
    name: "wall-poster",
    path: "/wall-poster-reports",
    component: () =>
      import(
        /* webpackChunkName: "chunks/scheduling-reports" */ "@views/scheduling_reports/WallPoster"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "gradebook_student_report",
    path: "/gradebook_student_report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/scheduling-reports" */ "@views/gradebook_reports/GradebookStudentReport"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "bifurcation_students",
    path: "/bifurcation-students",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registrations/registrations" */ "@views/registrations/bifurcation/StudentList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //     name: 'wall-poster',
  //     path: '/wall-poster-reports',
  //     component: () => import( /* webpackChunkName: "chunks/scheduling-reports" */ '@views/scheduling_reports/WallPoster'),
  //     meta: {
  //         requiresAuth: true
  //     }
  // },
  {
    name: "work-sectors",
    path: "/work-sectors",
    component: () =>
      import(
        /* webpackChunkName: "chunks/work-sectors" */ "@views/work_sectors/WorkSectorsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "relationship-statuses",
    path: "/relationship-statuses",
    component: () =>
      import(
        /* webpackChunkName: "chunks/relationship-statuses" */ "@views/relationship_statuses/RelationshipStatusesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_relationship_status"),
  },
  {
    name: "transfer-statuses",
    path: "/transfer-statuses",
    component: () =>
      import(
        /* webpackChunkName: "chunks/transfer-statuses" */ "@views/transfer_statuses/TransferStatusesList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "education-statuses",
    path: "/education-statuses",
    component: () =>
      import(
        /* webpackChunkName: "chunks/education-statuses" */ "@views/education_statuses/EducationStatusesList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "enrollment-statuses",
    path: "/enrollment-statuses",
    component: () =>
      import(
        /* webpackChunkName: "chunks/enrollment-statuses" */ "@views/enrollment_statuses/EnrollmentStatusesList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "color-groups",
    path: "/color-groups",
    component: () =>
      import(
        /* webpackChunkName: "chunks/color-groups" */ "@views/color_groups/ColorGroupsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_color_group"),
  },
  {
    name: "factors",
    path: "/factors",
    component: () =>
      import(
        /* webpackChunkName: "chunks/factors" */ "@views/factors/FactorsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_factor"),
  },
  // {
  //     name: 'skills',
  //     path: '/skills',
  //     component: () =>
  //         import ( /* webpackChunkName: "chunks/skills" */ '@views/skills/SkillsList'),
  //     meta: {
  //         requiresAuth: true
  //     }
  // },
  // {
  //     name: 'skills',
  //     path: '/skills',
  //     component: () => import( /* webpackChunkName: "chunks/skills" */ '@views/skills/SkillsList'),
  //     meta: {
  //         requiresAuth: true
  //     }
  // },
  {
    name: "weekly-plans",
    path: "/weekly-plans",
    component: () =>
      import(
        /* webpackChunkName: "chunks/weekly-plans" */ "@views/weekly_plans/WeeklyPlansList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_weekly_plan"),
  },
  {
    name: "marking-periods",
    path: "/marking-periods",
    component: () =>
      import(
        /* webpackChunkName: "chunks/marking-periods" */ "@views/marking_periods/MarkingPeriodsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_marking_period"),
  },
  {
    name: "grade-books",
    path: "/grade-books",
    component: () =>
      import(
        /* webpackChunkName: "chunks/grade-books" */ "@views/grade_books/GradeBooksList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_grade_book"),
  },
  {
    name: "publishGradebook",
    path: "/publishGradebook",
    component: () =>
      import(
        /* webpackChunkName: "chunks/publish-gradebook" */ "@views/publish_gradebook/PublishGradebookList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "columns",
    path: "/columns",
    component: () =>
      import(
        /* webpackChunkName: "chunks/columns" */ "@views/columns/ColumnsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_column"),
  },
  {
    name: "monthly-attendance-report",
    path: "/monthly-attendance-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/monthly-attendance-report" */ "@views/gradebook_reports/MonthlyAttendance"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard([
      "view_gradebook_reports",
      "view_monthly_attendance_report",
    ]),
  },
  {
    name: "grade-book-report",
    path: "/grade-book-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/grade-book-report" */ "@views/gradebook_reports/GradeBook"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_gradebook_reports"),
  },
  {
    name: "delayed-grade-book-report",
    path: "/delayed-grade-book-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/delayed-grade-book-report" */ "@views/gradebook_reports/DelayedGradeBook"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_gradebook_reports"),
  },
  {
    name: "progress-report",
    path: "/progress-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/progress-report" */ "@views/gradebook_reports/ProgressReport"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_gradebook_reports"),
  },
  {
    name: "gradebook-reports",
    path: "/gradebook-reports",
    component: () =>
      import(
        /* webpackChunkName: "chunks/gradebook-reports" */ "@views/gradebook_reports/Index"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_gradebook_reports"),
  },
  {
    name: "merit-report",
    path: "/merit-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/merit-report" */ "@views/gradebook_reports/MeritReport"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_merit_reports"),
  },
  {
    name: "grades-report",
    path: "/grades-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/grades-report" */ "@views/gradebook_reports/GradesReport"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_gradebook_reports"),
  },
  {
    name: "students-rank-report",
    path: "/students-rank-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/grades-report" */ "@views/gradebook_reports/StudentsRankReport"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_gradebook_reports"),
  },
  {
    name: "attendance-rank-report",
    path: "/attendance-rank-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/grades-report" */ "@views/gradebook_reports/AttendanceRankReport"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard([
      "view_gradebook_reports",
      "view_attendance_rank_report",
    ]),
  },
  {
    name: "skills-report",
    path: "/skills-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/grades-report" */ "@views/gradebook_reports/SkillReport"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_gradebook_reports"),
  },
  {
    name: "ib-report",
    path: "/ib-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/ib-report" */ "@views/gradebook_reports/IBReport"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_gradebook_reports"),
  },
  {
    name: "report-card-admin",
    path: "/report-card-admin",
    component: () =>
      import(
        /* webpackChunkName: "chunks/report-card-admin" */ "@views/gradebook_reports/ReportCardAdmin"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_gradebook_reports"),
  },
  {
    name: "ib",
    path: "/ib",
    redirect: "/ib/learner-profiles",
  },
  {
    name: "ib-learner-profiles",
    path: "/ib/learner-profiles",
    component: () =>
      import(
        /* webpackChunkName: "chunks/ib-settings" */ "@views/admin/ib/Index"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_learner_profile"),
  },
  {
    name: "ib-atl-categories",
    path: "/ib/atl-categories",
    component: () =>
      import(
        /* webpackChunkName: "chunks/ib-settings" */ "@views/admin/ib/Index"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_atl_category"),
  },
  {
    name: "ib-atl-skills",
    path: "/ib/atl-skills",
    component: () =>
      import(
        /* webpackChunkName: "chunks/ib-settings" */ "@views/admin/ib/Index"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_atl_skill"),
  },
  {
    name: "ib-myp-boundaries",
    path: "/ib/myp-boundaries",
    component: () =>
      import(
        /* webpackChunkName: "chunks/ib-settings" */ "@views/admin/ib/Index"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_myp_boundary"),
  },
  {
    name: "grades",
    path: "/grades",
    component: () =>
      import(
        /* webpackChunkName: "chunks/teachers/grades" */ "@views/teachers/grade_book/Grades"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "attendance",
    path: "/attendance",
    component: () =>
      import(
        /* webpackChunkName: "chunks/teachers/attendance" */ "@views/teachers/grade_book/Attendance"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "period_attendance",
    path: "/period_attendance",
    component: () =>
      import(
        /* webpackChunkName: "chunks/period_attendance/attendance" */ "@views/period_attendance/Attendance"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("add_student_daily_attendance"),
  },
  {
    name: "teacher_attendance",
    path: "/teacher_attendance",
    component: () =>
      import(
        /* webpackChunkName: "chunks/period_attendance/attendance" */ "@views/period_attendance/TeacherAttendance"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_teacher_attendance"),
  },
  {
    name: "substitute_teacher_appointment",
    path: "/substitute-teacher-appointment",
    component: () =>
      import(
        /* webpackChunkName: "chunks/period_attendance/substitute" */ "@views/period_attendance/SubstituteTeacherAppointment"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("add_substitute_teacher"),
  },
  {
    name: "home_room_attendance",
    path: "/home_room_attendance",
    component: () =>
      import(
        /* webpackChunkName: "chunks/home_room_attendance/attendance" */ "@views/home_room_attendance/Attendance"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("add_attendance"),
  },
  {
    name: "merits",
    path: "/merits",
    component: () =>
      import(
        /* webpackChunkName: "chunks/teachers/merits" */ "@views/merits/MeritsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_merit"),
  },
  {
    name: "teacher-weekly-plans",
    path: "/teacher-weekly-plans",
    component: () =>
      import(
        /* webpackChunkName: "chunks/teachers/teacher-weekly-plans" */ "@views/teachers/weekly_plans/WeeklyPlansList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "papers",
    path: "/papers",
    component: () =>
      import(
        /* webpackChunkName: "chunks/papers" */ "@views/papers/PapersList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "penalties",
    path: "/penalties",
    component: () =>
      import(
        /* webpackChunkName: "chunks/penalties" */ "@views/penalties/PenaltyList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_penalty"),
  },
  {
    name: "incidents",
    path: "/incidents",
    component: () =>
      import(
        /* webpackChunkName: "chunks/incidents" */ "@views/incidents/IncidentList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_incident"),
  },
  {
    name: "incidents-create",
    path: "/incidents/create",
    component: () =>
      import(
        /* webpackChunkName: "chunks/teacher-dashboard" */ "@views/incidents/IncidentFormNew"
      ),
    meta: {
      requiresAuth: true,
    },
  },

  {
    name: "incidents-edit",
    path: "/incidents/edit/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/teacher-dashboard" */ "@views/incidents/IncidentFormNew"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "bus-incidents",
    path: "/bus-incidents",
    component: () =>
      import(
        /* webpackChunkName: "chunks/bus/incidents" */ "@views/bus_incidents/IncidentList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_discipline"),
  },
  {
    name: "incident_reports",
    path: "/incident_reports",
    component: () =>
      import(
        /* webpackChunkName: "chunks/incident_reports" */ "@views/incident_reports/Index"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "incident_report",
    path: "/incident_report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/incident_report" */ "@views/incident_reports/IncidentReport"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_incident_reports"),
  },
  {
    name: "violations",
    path: "/violations",
    component: () =>
      import(
        /* webpackChunkName: "chunks/violations" */ "@views/violations/ViolationList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_violation"),
  },
  {
    name: "locations",
    path: "/locations",
    component: () =>
      import(
        /* webpackChunkName: "chunks/violations" */ "@views/locations/LocationList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_location"),
  },
  {
    name: "actions",
    path: "/actions",
    component: () =>
      import(
        /* webpackChunkName: "chunks/actions" */ "@views/actions/ActionList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_action"),
  },
  {
    name: "attendance-reports",
    path: "/attendance-reports",
    component: () =>
      import(
        /* webpackChunkName: "chunks/attendance_reports" */ "@views/attendance_reports/Index"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "period-homeroom-attendance-report",
    path: "/period-homeroom-attendance-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/attendance_reports" */ "@views/attendance_reports/period_homeroom_attendance"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_period_attendance_per_homeroom"),
  },
  {
    name: "period-attendance-report",
    path: "/period-attendance-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/attendance_reports" */ "@views/attendance_reports/period_attendance"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_period_attendance_per_period"),
  },
  {
    name: "period-subject-attendance-report",
    path: "/period-subject-attendance-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/attendance_reports" */ "@views/attendance_reports/period_subject_attendance"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_period_attendance_per_subject"),
  },
  {
    name: "code-attendance-report",
    path: "/code-attendance-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/attendance_reports" */ "@views/attendance_reports/code_attendance"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_attendance_as_per_attendance_code"),
  },
  {
    name: "penalties-report",
    path: "/penalties-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/penalties_Report" */
        "@views/incident_reports/penalties_Report"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_penalty_reports"),
  },
  {
    name: "statistical-discipline-report",
    path: "/statistical-discipline-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/statistical-despline-report" */
        "@views/incident_reports/statistical_despline_actions"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_discipline_statistics"),
  },
  {
    name: "individual-attendance-report",
    path: "/individual-attendance-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/attendance_reports" */ "@views/attendance_reports/individual_attendance"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_individual_attendance_for_student"),
  },
  {
    name: "statistical-attendance-report",
    path: "/statistical-attendance-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/attendance_reports" */ "@views/attendance_reports/statistical_attendance"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_statistical_attendance"),
  },
  {
    name: "daily-statistical-attendance-report",
    path: "/attendance/report/daily-statistical",
    component: () =>
      import(
        /* webpackChunkName: "chunks/attendance_reports" */ "@views/attendance_reports/dailyStatistical"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard(
      "view_daily_statistical_attendance_by_period_report"
    ),
  },
  {
    name: "subject-attendance-report",
    path: "/attendance/report/subject",
    component: () =>
      import(
        /* webpackChunkName: "chunks/attendance_reports" */ "@views/attendance_reports/subject_attendance"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_subject_attendance_report"),
  },

  {
    name: "daily-statistical-attendance-timetable-report",
    path: "/attendance/report/timetable-daily-statistical",
    component: () =>
      import(
        /* webpackChunkName: "chunks/attendance_reports" */ "@views/attendance_reports/dailyStatisticalTimetable"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard(
      "view_daily_statistical_attendance_by_timetable"
    ),
  },
  {
    name: "month-statistical-attendance-report",
    path: "/attendance/report/month-statistical",
    component: () =>
      import(
        /* webpackChunkName: "chunks/attendance_reports" */ "@views/attendance_reports/monthStatistical"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_monthly_absence_statistics"),
  },
  {
    name: "annual-statistical-attendance-report",
    path: "/attendance/report/annual-statistical",
    component: () =>
      import(
        /* webpackChunkName: "chunks/attendance_reports" */ "@views/attendance_reports/annualStatistical"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_annual_absence_statistics"),
  },
  {
    name: "show-notification",
    path: "/show-notifications",
    component: () =>
      import(
        /* webpackChunkName: "chunks/notifications" */ "@views/notifications/NotificationsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_notification"),
  },
  {
    name: "notification-settings",
    path: "/notification-settings",
    component: () =>
      import(
        /* webpackChunkName: "chunks/notification_settings" */ "@views/notification_settings/NotificationSettingsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_notification"),
  },

  {
    name: "notifications-new",
    path: "/notifications-new",
    component: () =>
      import(
        /* webpackChunkName: "chunks/notification_settings" */ "@views/notifications/notification_settings/NotificationSettingsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_notification"),
  },

  {
    name: "/admission/admission-users",
    path: "/admission/admission-users",
    component: () =>
      import(
        /* webpackChunkName: "chunks/admissions/admission-users" */ "@views/admissions/admission_users/AdmissionUsersList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_admission_users"),
  },
  {
    path: "/admission/admission-users/create",
    name: "AdmissionUserCreate",
    component: () =>
      import("@/views/admissions/admission_users/AdmissionUserCreate.vue"),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("add_admission_users"),
  },
  {
    name: "/admission/admission-users/student-papers",
    path: "/admission/admission-users/student-papers/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/admissions/admission-users/student-papers" */ "@views/admissions/student_papers/StudentPapersList"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    name: "/admission/admission-papers",
    path: "/admission/admission-papers",
    component: () =>
      import(
        /* webpackChunkName: "chunks/admissions/admission-users/admission-papers" */ "@views/admissions/student_papers/AdmissionPapers"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },

  {
    name: "/student/student-papers",
    path: "/student/student-papers/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/student-papers" */ "@views/student_papers/StudentPapersList"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
    beforeEnter: canAccessGuard("view_papers_students"),
  },
  {
    name: "/student/admission-papers",
    path: "/student/admission-papers/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/students/admission-papers" */ "@views/admission_papers/AdmissionPapersList"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    name: "/admission/work-sector",
    path: "/admission/work-sector",
    component: () =>
      import(
        /* webpackChunkName: "chunks/admissions/work-sectors" */ "@views/admissions/work_sectors/WorkSectorsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "/admission/civil-status",
    path: "/admission/civil-status",
    component: () =>
      import(
        /* webpackChunkName: "chunks/admissions/civil-status" */ "@views/admissions/civil_status/CivilStatusList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_civil_status"),
  },
  {
    name: "/admission/required-papers",
    path: "/admission/required-papers",
    component: () =>
      import(
        /* webpackChunkName: "chunks/admissions/required-papers" */ "@views/admissions/required_papers/RequiredPapersList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_required_papers"),
  },
  {
    name: "interview-schedules",
    path: "/interview-schedules",
    component: () =>
      import(
        /* webpackChunkName: "chunks/interview_schedules" */ "@views/interview_schedules/InterviewSchedulesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_schedule_interviews"),
  },
  {
    name: "interview-requests",
    path: "/interview-requests",
    component: () =>
      import(
        /* webpackChunkName: "chunks/interview_requests" */ "@views/interview_requests/InterviewNewRequestsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_interview_requests"),
  },
  {
    name: "/school-criteria",
    path: "/school-criterias",
    component: () =>
      import(
        /* webpackChunkName: "chunks/school_criteria" */ "@views/school_criteria/SchoolCriteriaList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_school_age_criteria_school_crieteria"),
  },
  {
    name: "interview-requests/accepted",
    path: "/interview-requests/accepted",
    component: () =>
      import(
        /* webpackChunkName: "chunks/interview_requests" */ "@views/interview_requests/AcceptedInterviewRequestsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "interview-requests/refused",
    path: "/interview-requests/refused",
    component: () =>
      import(
        /* webpackChunkName: "chunks/interview_requests" */ "@views/interview_requests/RefusedInterviewRequestsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },

  {
    name: "interview-results",
    path: "/interview-results",
    component: () =>
      import(
        /* webpackChunkName: "chunks/interview-results" */ "@views/interview_requests/InterviewRequestsResultList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_interview_results"),
  },
  {
    name: "yearLevel-seats",
    path: "/yearLevelSeats",
    component: () =>
      import(
        /* webpackChunkName: "chunks/year_level_seats" */ "@views/year_level_seats/YearLevelSeatsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_year_level_seats"),
  },
  {
    name: "waiting-list",
    path: "/waiting-list",
    /*  component: () => import( /!* webpackChunkName: "chunks/waiting-list" *!/ '@views/waiting-list/WaitingList'),
     */
    component: () =>
      import(
        /* webpackChunkName: "chunks/waiting-list" */ "@views/interview_requests/InterviewRequestsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_waiting_list"),
  },
  {
    name: "interview-status",
    path: "/interview-statuses",
    component: () =>
      import(
        /* webpackChunkName: "chunks/waiting-list" */ "@views/waiting-list/WaitingList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "districts",
    path: "/districts",
    component: () =>
      import(
        /* webpackChunkName: "chunks/district" */ "@views/districts/DistrictList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_district"),
  },
  {
    name: "administrative-regions",
    path: "/administrative-regions",
    component: () =>
      import(
        /* webpackChunkName: "chunks/administrative-regions" */ "@views/administrative_regions/RegionList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_region"),
  },
  {
    name: "disability-types",
    path: "/disability-types",
    component: () =>
      import(
        /* webpackChunkName: "chunks/district" */ "@views/disability_types/DisabilityTypeList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_disability_type"),
  },
  {
    name: "nationalities",
    path: "/nationalities",
    component: () =>
      import(
        /* webpackChunkName: "chunks/nationalities" */ "@views/nationalities/NationalitiesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_nationality"),
  },
  {
    name: "areas",
    path: "/areas",
    component: () =>
      import(/* webpackChunkName: "chunks/area" */ "@views/areas/AreaList"),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_areas"),
  },
  {
    name: "blocks",
    path: "/blocks",
    component: () =>
      import(/* webpackChunkName: "chunks/block" */ "@views/blocks/BlockList"),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_blocks"),
  },
  {
    name: "streets",
    path: "/streets",
    component: () =>
      import(
        /* webpackChunkName: "chunks/street" */ "@views/streets/StreetList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "work-places",
    path: "/work-places",
    component: () =>
      import(
        /* webpackChunkName: "chunks/work-places" */ "@views/work_places/WorkPlacesList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "registrations",
    path: "/registrations",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registrations/registrations" */ "@views/registrations/registrations/RegistrationList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "emergency_contract",
    path: "/students/:family_id/emergency-contracts",
    component: () =>
      import(
        /* webpackChunkName: "chunks/emergency_contacts" */ "@views/emergency_contacts/StudentsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "medical_information",
    path: "/students/:family_id/medical-informations",
    component: () =>
      import(
        /* webpackChunkName: "chunks/medical_information" */ "@views/medical_information/MedicalInfoList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "access_family",
    path: "/families/access-families/:family_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/families/access_family" */ "@views/families/access_family/AccessList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("access_family_students"),
  },
  {
    name: "family_payment_collection",
    path: "/families/payment-collection/:family_id",
    component: () =>
      import("@views/families/access_family/payment/collectionIndex"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/families/access-families/:family_id/students/add",
    name: "AddStudentAdmin",
    component: () => import("@/views/students/wizard/StudentFormWizard"),
    props: (route) => ({
      family: { id: route.params.family_id },
    }),
    meta: { requiresAuth: true, role: "admin" },
  },
  {
    path: "/families/access-families/:family_id/students/:student_id/edit",
    name: "EditStudentAdmin",
    component: () => import("@/views/students/wizard/StudentFormWizard"),
    props: (route) => ({
      family: { id: route.params.family_id },
      student: { id: route.params.student_id },
      isUpdateMode: true,
    }),
    meta: { requiresAuth: true, role: "admin" },
  },
  {
    name: "add_mother",
    path: "/families/add-mother/:family_id",
    component: () => import("@views/families/mother/MotherForm"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "edit_mother",
    path: "/families/:family_id/edit-mother/:mother_id",
    component: () => import("@views/families/mother/MotherForm"),
    meta: {
      requiresAuth: true,
    },
  },
  //Hide printed letters
  // {
  //     name: 'Printed_letters',
  //     path: '/Printed-letters',
  //     component: () =>
  //         import( /* webpackChunkName: "chunks/Printed_letters" */ '@views/Printed_letters/Index'),
  //     meta: {
  //         requiresAuth: true
  //     }
  // },
  {
    name: "previous_schools",
    path: "/PreviousSchools",
    component: () =>
      import(
        /* webpackChunkName: "chunks/previousSchools" */ "@views/previous_schools/SchoolList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_previous_school"),
  },
  {
    name: "guardian_information",
    path: "/students/:family_id/guardian_information",
    component: () =>
      import(
        /* webpackChunkName: "chunks/families/guardian_information" */ "@views/families/guardian_information/GuardiansList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "added_guardian_information",
    path: "/students/:family_id/added_guardian_information",
    component: () =>
      import(
        /* webpackChunkName: "chunks/families/guardian_information" */ "@views/families/guardian_information/GuardianFormWizard"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "registered_students",
    path: "/registered-students",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registered_students" */ "@views/students_registered/StudentsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_registered_students"),
  },
  {
    name: "students_on_hold",
    path: "/students-on-hold",
    component: () =>
      import(
        /* webpackChunkName: "chunks/students_on_hold" */ "@views/students_on_hold/StudentsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "history_information",
    path: "/students/:family_id/PreviousSchoolStudent",
    component: () =>
      import(
        /* webpackChunkName: "chunks/previous_school_students" */ "@views/previous_school_students/StudentsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "admission_report",
    path: "/admission-users/admission-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/admissions" */ "@views/admissions/AdmissionReport"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_admission_report"),
  },

  {
    name: "record_report",
    path: "/students/record-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration_reports" */ "@views/registration_reports/RecordReport"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "register_report",
    path: "/students/register-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registrations/RegisterReport"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_register_report"),
  },
  {
    name: "student_data_report",
    path: "/students/student-data-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports/StudentDataReport"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_student_date_report"),
  },
  {
    name: "statistical_register_report",
    path: "/students/statistical-register-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registrations/StatisticalRegisterReport"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "special_needs_report",
    path: "/students/special-needs-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registrations/SpecialNeedsReport"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "special_needs",
    path: "/students/report/special-needs",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports/SpecialNeeds.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },

  {
    name: "special_needs_enhanced",
    path: "/students/report/special-needs-enhanced",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/SpecialNeeds.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "enrolled_or_re_enrolled_report",
    path: "/students/report/enrolled-re-enrolled-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports/EnrollmentReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_students_enrollment_report"),
  },
  {
    name: "classes_by_study_status_report",
    path: "/students/report/classes-by-study-status",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports/ClassesByStudyStatus.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_classes_by_study_status_report"),
  },
  {
    name: "classes_by_study_status_report_enhanced",
    path: "/students/report/classes-by-study-status-enhanced",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/ClassesByStudyStatus.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "withdrawal-students-report",
    path: "/students/report/withdrawals",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports/WithdrawalsReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },

  {
    name: "withdrawal-students-report-enhanced",
    path: "/students/report/withdrawals-enhanced",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/WithdrawalsReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "student_data_report_enhanced",
    path: "/students/student-data-report-enhanced",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/WithdrawalsReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "educational_state_report_enhanced",
    path: "/educational-state-report-enhanced",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/educational_state/EducationalState.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "new_students_report_enhanced",
    path: "/registration-new-students-report-enhanced",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/NewStudentsReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_new_students_registration_report"),
  },
  {
    name: "new_students_report",
    path: "/new-students-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/NewStudentsReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_new_students_registration_report"),
  },
  // {
  //     name: 'unenrollment_students_report_enhanced',
  //     path: '/unenrollment-students-enhanced',
  //     component: () =>
  //         import( /* webpackChunkName: "chunks/registration" */ '@views/registration_reports_enhanced/UnenrollmentStudentsReport.vue'),
  //     meta: {
  //         requiresAuth: true
  //     }
  // },
  // {
  //     name: 'student_history_report_enhanced',
  //     path: '/student-history-report-enhanced',
  //     component: () =>
  //         import( /* webpackChunkName: "chunks/registration" */ '@views/registration_reports_enhanced/StudentHistoryReport.vue'),
  //     meta: {
  //         requiresAuth: true
  //     }
  // },
  {
    name: "orphan_students_report_enhanced",
    path: "/orphan-student-report-enhanced",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/OrphanStudentsReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "parent_logs_report_enhanced",
    path: "/parent-logs-report-enhanced",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/ParentLogsReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "re_enrollment_report_enhanced",
    path: "/re-enrollment-report-enhanced",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/ReEnrollmentReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //     name: 'students_by_class_report_enhanced',
  //     path: '/students-by-class-report-enhanced',
  //     component: () =>
  //         import( /* webpackChunkName: "chunks/registration" */ '@views/registration_reports_enhanced/StudentsByClassReport.vue'),
  //     meta: {
  //         requiresAuth: true
  //     }
  // },
  {
    name: "classes_with_civil_id_report_enhanced",
    path: "/registration-reports-enhanced/classes-with-civil-id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/ClassesWithCivilIdReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "classes_with_age_report_enhanced",
    path: "/registration-reports-enhanced/classes-students-with-age",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/ClassesWithAgeReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "classes_by_nationality_religion_report_enhanced",
    path: "/classes-by-nationality-and-religion-enhanced",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/ClassesByNationalityAndReligionReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "enrollment_report_enhanced",
    path: "/enrollment-report-enhanced",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/EnrollmentReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "external_transfer_cert_enhanced",
    path: "/external-transfer-cert-enhanced",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/ExternalTransferCert.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "internal_transfer_cert_enhanced",
    path: "/internal-transfer-cert-enhanced",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/InternalTransferCert.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "record_report_enhanced",
    path: "/record-report-enhanced",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/RecordReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "stage_student_type_enhanced",
    path: "/stage-student-type-enhanced",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/StageStudentType.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "statement_report_enhanced",
    path: "/statement-report-enhanced",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports_enhanced/StatementReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //     name: 'transformation_students_report_enhanced',
  //     path: '/transformation-students-report-enhanced',
  //     component: () =>
  //         import( /* webpackChunkName: "chunks/registration" */ '@views/registration_reports_enhanced/TransformationStudentsReport.vue'),
  //     meta: {
  //         requiresAuth: true
  //     }
  // },
  {
    name: "transformation-students-report",
    path: "/students/report/transformation-students",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports/TransformationStudentsReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_student_transformation_reports"),
  },
  {
    name: "students-statement",
    path: "/students/report/statement",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports/StatementReport.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_statement_about_student_continuity"),
  },
  {
    name: "internal-transfer-cert",
    path: "/students/report/internal-transfer-cert",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports/InternalTransferCert.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "external-transfer-cert",
    path: "/students/report/external-transfer-cert",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registration_reports/ExternalTransferCert.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //     name: 'statistical_report',
  //     path: '/students/statistical-report',
  //     component: () =>
  //         import ( /* webpackChunkName: "chunks/registration" */ '@views/registrations/StatisticalReport'),
  //     meta: {
  //         requiresAuth: true
  //     }
  // },
  {
    name: "student_normal_statistical_report",
    path: "/normal-statistical-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registrations/StatisticalStudentNormalReport"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "student_mix_statistical_report",
    path: "/mix-statistical-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registrations/StatisticalStudentMixReport"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "students_statistical_report",
    path: "/students-statistical-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/registrations/StudentsStatisticalReport"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "registration-reports",
    path: "/registration-reports",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/registration_reports/Index"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_registration_tap_reports"),
  },
  {
    name: "registration-reports-enhanced",
    path: "/registration-reports-enhanced",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/registration_reports_enhanced/Index"
      ),
    meta: {
      requiresAuth: true,
    },
  },

  {
    name: "stop_types",
    path: "/stop-types",
    component: () =>
      import(
        /* webpackChunkName: "chunks/stop_types" */ "@views/stopTypes/stopTypeList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_stop_type"),
  },
  {
    name: "route_stoppage",
    path: "/routesStoppage",
    component: () =>
      import(
        /* webpackChunkName: "chunks/route_stoppage" */ "@views/routes/RouteList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_route"),
  },
  {
    name: "bus_details",
    path: "/buses",
    component: () =>
      import(
        /* webpackChunkName: "chunks/bus_details" */ "@views/buses/BusList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_bus_details"),
  },
  {
    name: "books_subjects",
    path: "/bookSubjects",
    component: () =>
      import(
        /* webpackChunkName: "chunks/book_subjects" */ "@views/book_subjects/BookSubjectsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_book_subject"),
  },
  {
    name: "books_catalogue",
    path: "/bookCatalogs",
    component: () =>
      import(
        /* webpackChunkName: "chunks/book_catalogues" */ "@views/book_catalogues/BookCataloguesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_book_catalog"),
  },
  {
    name: "general_setting",
    path: "/schoolMeta",
    component: () =>
      import(
        /* webpackChunkName: "chunks/school_meta" */ "@views/school_meta/MetaForm"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_staff_setting"),
  },
  {
    name: "library-settings",
    path: "/library-settings",
    component: () =>
      import(
        /* webpackChunkName: "chunks/library_setting" */ "@views/library_setting/LibrarySettingList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_library_setting"),
  },
  {
    name: "districts_module",
    path: "/districts/dashboard",
    component: () =>
      import(
        /* webpackChunkName: "chunks/districts_module" */ "@views/district_module/Dashboard"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "bus_comments",
    path: "bus-comments",
    component: () =>
      import(
        /* webpackChunkName: "chunks/bus_commented" */ "@views/bus_commented/commentList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_bus_comment"),
  },
  {
    name: "bus_comment_report",
    path: "bus-comment-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/bus_comment_report" */ "@views/bus_commented/commentReport"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_bus_comment_report"),
  },
  {
    name: "bus_report",
    path: "bus-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/bus_report" */ "@views/buses/BusReport"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_bus_report"),
  },
  {
    name: "route_report",
    path: "route-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/route_report" */ "@views/routes/RouteReport"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_route_report"),
  },
  {
    name: "transformations",
    path: "transformations",
    component: () =>
      import(
        /* webpackChunkName: "chunks/transformations" */ "@views/transformations/TransformationList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "district_reports",
    path: "/district_reports",
    component: () =>
      import(
        /* webpackChunkName: "chunks/district_reports" */ "@views/district_reports/Index"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "transformation_report",
    path: "/transformation_report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/district_reports" */ "@views/district_reports/TransformationReport"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "discipline_report",
    path: "/discipline_report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/district_reports" */ "@views/district_reports/DisciplineReport"
      ),
    meta: {
      requiresAuth: true,
    },
  },

  {
    name: "library-books",
    path: "books",
    component: () =>
      import(/* webpackChunkName: "chunks/books" */ "@views/books/BookList"),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_book"),
  },
  {
    name: "account_management",
    path: "library-members",
    component: () =>
      import(
        /* webpackChunkName: "chunks/library_members" */ "@views/library_members/LibraryMembersList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_library_member"),
  },

  {
    name: "books-item",
    path: "books/:id",
    component: () =>
      import(/* webpackChunkName: "chunks/books" */ "@views/books/BookItem"),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_book"),
  },
  {
    name: "book-items",
    path: "book-items/:book",
    component: () =>
      import(
        /* webpackChunkName: "chunks/books-items" */ "@views/books_items/BookItemList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_details_book"),
  },
  {
    name: "book-items-checkout",
    path: "checkout/books/:book",
    component: () =>
      import(
        /* webpackChunkName: "chunks/books-items" */ "@views/books_items/LoanBookItemList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_borrowing_book"),
  },
  {
    name: "book-checkout",
    path: "checkout/books",
    component: () =>
      import(
        /* webpackChunkName: "chunks/books-items" */ "@views/books/CheckoutBookList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_borrowing_book"),
  },
  {
    name: "book-items-action",
    path: "book-items/:item/action/:action",
    component: () =>
      import(
        /* webpackChunkName: "chunks/books-items" */ "@views/books_items/BookItemForm"
      ),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "library-reports",
    path: "/library-reports",
    component: () =>
      import(
        /* webpackChunkName: "chunks/library_reports" */ "@views/library_reports/Index"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "membership-report",
    path: "/membership-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/library_reports" */ "@views/library_reports/membership_report"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_memberships_report"),
  },
  {
    name: "books",
    path: "book-movements",
    component: () =>
      import(
        /* webpackChunkName: "chunks/book_movements" */ "@views/book_movements/BookMovementsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "book-report",
    path: "book-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/book_movements" */ "@views/library_reports/book_report"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_books_report"),
  },
  {
    name: "district_attendance_report",
    path: "/district_attendance_report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/district_attendance_report" */ "@views/district_reports/AttendanceReport"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "district_staff_report",
    path: "/district_staff_report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/district_staff_report" */ "@views/district_reports/StaffReport"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "book-items-report",
    path: "/book-items-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/library_reports" */ "@views/library_reports/book_item_report"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_book_items_status_report"),
  },
  {
    name: "bus-registrations",
    path: "/bus-registrations",
    component: () =>
      import(
        /* webpackChunkName: "chunks/bus_registration" */ "@views/bus_registration/BusRegistrationList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_bus_registration"),
  },
  {
    name: "bus-registrations/groups",
    path: "/bus-registrations/groups",
    component: () =>
      import(
        /* webpackChunkName: "chunks/bus_registration" */ "@views/bus_registration/GroupingBusRegistrationList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_bus_registration"),
  },
  {
    name: "bus-registrations/bus-student",
    path: "/bus-registrations/bus-student",
    component: () =>
      import(
        /* webpackChunkName: "chunks/bus_registration" */ "@views/bus_registration/BusStudentRegistrationList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_bus_student"),
  },
  {
    name: "bus-attendance-going",
    path: "bus-attendance/going",
    component: () =>
      import(
        /* webpackChunkName: "chunks/bus_attendance" */ "@views/bus_attendance/BusGoingAttendanceList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "bus-attendance-report",
    path: "bus-attendance-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/bus_attendance" */ "@views/transportationAttendanceReport/BusAttendanceReport"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_bus_attendance_report"),
  },
  {
    name: "transportation_reports",
    path: "transportation_reports",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/transportation_report/Index"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Printings",
    path: "transportation_printings",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/transportation_report/Printing"
      ),
    meta: {
      requiresAuth: true,
    },
  },

  {
    name: "bus-attendance-return",
    path: "bus-attendance/return",
    component: () =>
      import(
        /* webpackChunkName: "chunks/bus_attendance" */ "@views/bus_attendance/BusReturnAttendanceList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_bus_attendance"),
  },

  {
    name: "students_transformations",
    path: "/students_transformations",
    component: () =>
      import(
        /* webpackChunkName: "chunks/students_transformations" */ "@views/students_transformations/transformationList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_student_transfer"),
  },
  {
    name: "printed_bus_pass",
    path: "/printed_bus_pass",
    component: () =>
      import(
        /* webpackChunkName: "chunks/printed_bus_pass" */ "@views/bus_registration/printedBusPass"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "trips",
    path: "/trips",
    component: () =>
      import(/* webpackChunkName: "chunks/trips" */ "@views/trips/TripList"),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_trip"),
  },
  {
    name: "trips_requests",
    path: "/trips_requests",
    component: () =>
      import(
        /* webpackChunkName: "chunks/trips_requests" */ "@views/trips_requests/TripRequestList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_trip_request"),
  },
  {
    name: "AccessStudentsList",
    path: "/trip/access_students/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/trips/students" */ "@views/trips/AccessStudentsList"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
    beforeEnter: canAccessGuard("access_students_trip"),
  },
  {
    name: "transportation-printed-papers",
    path: "/transportation-printed-papers",
    component: () =>
      import(
        /* webpackChunkName: "chunks/transportation_printed_papers" */ "@views/transportation_printed_papers/TransportationPrintedPaperList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "merit_reasons",
    path: "/merit-reasons",
    component: () =>
      import(
        /* webpackChunkName: "chunks/merit-reasons" */ "@views/merit_reasons/MeritsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_merit_reason"),
  },
  {
    name: "violation_categories",
    path: "/violation-categories",
    component: () =>
      import(
        /* webpackChunkName: "chunks/violation_categories" */ "@views/violation_categories/ViolationCategoriesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_violation_category"),
  },
  {
    name: "complaint_types",
    path: "/complaint-types",
    component: () =>
      import(
        /* webpackChunkName: "chunks/complaint_types" */ "@views/complaint_types/ComplaintTypesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_complaint_type"),
  },

  {
    name: "complaints",
    path: "/complaints",
    component: () =>
      import(
        /* webpackChunkName: "chunks/complaints" */ "@views/complaints/ComplaintsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_complaint"),
  },
  {
    name: "student-group-attendance-report",
    path: "/student-group-attendance-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/student-group-attendance-report" */ "@views/attendance_reports/student_group_attendance"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "audits",
    path: "/audits",
    component: () =>
      import(/* webpackChunkName: "chunks/audits" */ "@views/audits/AuditList"),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_audit"),
  },
  {
    name: "holidays",
    path: "/holidays",
    component: () =>
      import(
        /* webpackChunkName: "chunks/holidays" */ "@views/holidays/HolidaysList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_holiday"),
  },
  {
    name: "group-meetings",
    path: "/group-meetings",
    component: () =>
      import(
        /* webpackChunkName: "chunks/group-meetings" */ "@views/group_meetings/GroupMeetingsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_group_meeting"),
  },
  {
    name: "hod",
    path: "/hod",
    component: () =>
      import(/* webpackChunkName: "chunks/hod" */ "@views/hod/HodList"),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_hod"),
  },
  {
    name: "GroupMeetingTeachers",
    path: "/group-meeting-teachers/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/trips/group-meetings" */ "@views/group_meetings/TeachersList"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    name: "class-student-transfer",
    path: "/class-student-transfer",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registrations/registrations" */ "@views/registrations/ClassStudentTransfer"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    name: "school-dashboard",
    path: "school-dashboard",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/SchoolDashboard"
      ),
    meta: {
      requiresAuth: true,
    },
  },

  {
    name: "announcements",
    path: "/announcements",
    component: () =>
      import(
        /* webpackChunkName: "chunks/announcements" */ "@views/school_ads/SchoolAdsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_school_ads"),
  },
  {
    name: "religions",
    path: "/religions",
    component: () =>
      import(
        /* webpackChunkName: "chunks/religions" */ "@views/religions/ReligionsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_religion"),
  },
  {
    name: "study-status",
    path: "/study-status",
    component: () =>
      import(
        /* webpackChunkName: "chunks/study-status" */ "@views/study_status/StudyStatusList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //     name: '/fee-type/:fee_type/detaidetailsls',
  //     path: 'fee-type/:fee_type/details',
  //     component: () => import( /* webpackChunkName: "chunks/dashboard" */ '@views/fee_types_details/FeeTypeDetailList'),
  //     meta: {
  //         requiresAuth: true
  //     },
  // },
  {
    name: "fee-types",
    path: "/fee-types/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/fee-types" */ "@views/fee_types_details/FeeTypeDetailList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_invoice_types"),
  },

  {
    name: "accepted-admissions",
    path: "/accepted-admissions",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/admission_fees/AcceptedAdmissionsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_invoice_admission"),
  },
  {
    name: "accepted-admissions/:admission/fee/:fee",
    path: "/accepted-admissions/:admission/fee/:fee",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/admission_fees/FeeTypeDetailModel"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "inventory-report",
    path: "inventory-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/inventory-report" */ "@views/library_reports/inventory_report"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_inventory_report"),
  },
  {
    name: "teacher_activities_report",
    path: "/teacher-activities-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/district_reports/TeacherActivities"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "parent_staff_discount",
    path: "/parent-staff-discount",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/discount/StaffList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "pickup-requests",
    path: "/pickup-requests",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/pickup_requests/PickUpRequestList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_parent_pickup_request"),
  },
  {
    name: "pickup-requests-supervisor",
    path: "/pickup-requests-supervisor",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/pickup_requests/PickUpRequestSupervisorList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("supervise_parent_pickup_request"),
  },
  {
    name: "pickup-supervisor-students",
    path: "/pickup-supervisor/:userId/students",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/pickup_requests/SupervisorStudentsManagement"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("supervise_parent_pickup_request"),
    props: true,
  },
  {
    name: "bus-types",
    path: "/bus-types",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/bus_types/BusTypesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_bus_type"),
  },
  {
    name: "bus-sizes",
    path: "/bus-sizes",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/bus_sizes/BusSizesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_bus_size"),
  },
  {
    name: "book-formats",
    path: "/book-formats",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/book_format/BookFormatsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_book_format"),
  },
  {
    name: "invoice-categories",
    path: "/invoice-categories/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/invoice_categories/InvoiceCategoriesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_invoice_categories"),
  },
  {
    name: "admission-invoices",
    path: "/admission-invoices/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/admission_invoices/AdmissionInvoicesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_admission_invoices"),
  },
  {
    name: "tuition-invoices",
    path: "/tuition-invoices/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/tuition_invoices/TuitionInvoicesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_tuition_invoices"),
  },
  {
    name: "clothes-invoices",
    path: "/clothes-invoices/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/clothes_invoices/ClothesInvoicesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_clothes_invoices"),
  },
  {
    name: "extensive-courses-invoices",
    path: "/extensive-courses-invoices/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/extensive_courses_invoices/InvoicesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_extensive_courses_invoices"),
  },

  {
    name: "bus-invoices",
    path: "/bus-invoices/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/bus_invoices/BusInvoicesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_bus_invoices"),
  },
  {
    name: "educational-supply-invoices",
    path: "/educational-supply-invoices/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/educational_supply_invoices/EducationalSupplyInvoicesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_book_invoices"),
  },
  {
    name: "staff-invoices",
    path: "/staff-invoices/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/staff_invoice/StaffList"
      ),
    meta: {
      requiresAuth: true,
    },
  },

  {
    name: "billing-academic-years",
    path: "/billing/academic-years",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_academic_year/AcademicYearsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "roles",
    path: "/roles",
    component: () =>
      import(/* webpackChunkName: "chunks/roles" */ "@views/roles/RolesList"),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_roles"),
  },
  {
    name: "schools",
    path: "/schools",
    component: () =>
      import(
        /* webpackChunkName: "chunks/schools" */ "@views/schools/SchoolsList"
      ),
    meta: {
      requiresAuth: true,
      permission: "VIEW_SCHOOLS",
    },
  },
  {
    name: "users",
    path: "/users",
    component: () =>
      import(/* webpackChunkName: "chunks/users" */ "@views/users/UsersList"),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_user"),
  },
  {
    name: "billing",
    path: "/billing/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_academic_year/Index"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "registration-discounts",
    path: "/registration-discounts/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/registration_discount/RegistrationDiscountsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_join_late_registration_discount"),
  },
  {
    name: "other-discounts",
    path: "/other-discounts/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/other_discount/OtherDiscountsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_discount"),
  },
  {
    name: "funding-plans",
    path: "/funding-plans/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/funding_plans/FundingPlanList"
      ),
    meta: {
      requiresAuth: true,
    },
  },

  // {
  //     name: 'funding-plans-invoices',
  //     path: '/funding-plans/:plan_id/invoices',
  //     component: () =>
  //         import ( /* webpackChunkName: "chunks/dashboard" */ '@views/plan_invoices/PlanInvoiceList'),
  //     meta: {
  //         requiresAuth: true
  //     }
  // },
  {
    name: "funding-plans-invoices",
    path: "/funding-plans/:plan_id/invoices/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/plan_invoices/PlanInvoiceList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "organization-fundings",
    path: "/organization-fundings/:organization_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/organization_fundings/OrganizationFundingList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "sibling-discounts",
    path: "/sibling-discounts/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/sibling_discounts/SiblingDiscountsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_sibling_discount"),
  },
  {
    name: "staff-discounts",
    path: "/staff-discounts/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/staff_discounts/StaffDiscountsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_staff_discount"),
  },
  {
    name: "withdrawal-discounts",
    path: "/withdrawal-discounts/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/withdrawal_discount/WithdrawalDiscountsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_withdrawal_discount"),
  },
  {
    name: "staff-payment",
    path: "/staff-payment",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/staff_invoice_payment/StaffInvoiceList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "billing-reports",
    path: "/billing-reports",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/Index"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "organizations-report",
    path: "/organizations-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/Organizations"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_report"),
  },

  {
    name: "funding-report",
    path: "/funding-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/Funding"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_report"),
  },

  {
    name: "contacts-report",
    path: "/contacts-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/connections/Connections"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_contacts_report"),
  },

  {
    name: "classes-by-phone-report",
    path: "/classes-by-phone-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/registrations/ClassesByPhone"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_classes_by_phone_report"),
  },

  {
    name: "classes-by-alpha",
    path: "/classes-by-alpha-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/registrations/ClassesByAlpha"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_classes_by_alpha"),
  },

  {
    name: "students-count-statistics-report",
    path: "/students-count-statistics-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/registrations/StudentsCountStatistics"
      ),
    meta: {
      requiresAuth: true,
    },
  },

  {
    name: "student-statement-report",
    path: "/student-statement-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/student_statments/StudentStatment"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_student_account_statement_report"),
  },
  {
    name: "classes-by-nationality-and-religion",
    path: "/classes-by-nationality-and-religion",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/registration_reports/classes_reports/class_nationality/ClassWithReligionAndNationality"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_class_students_by_nationality_religion"),
  },
  {
    name: "classes-with-civil-id",
    path: "/registration-reports/classes-with-civil-id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/registration_reports/classes_reports/class_civil/ClassWithCivil"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "classes-students-with-age",
    path: "/registration-reports/classes-students-with-age",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/registration_reports/classes_reports/class_age/ClassWithAge"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "student-history-report",
    path: "/student-history-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/registration_reports/student_history/StudentHistory"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "parent-statement-report",
    path: "/parent-statement-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/parent_statments/ParentStatment"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_parent_account_statement_report"),
  },
  {
    name: "student-balance-report",
    path: "/student-balance-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/student_balance/StudentBalance"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_student_balance_report"),
  },
  {
    name: "students-credits-report",
    path: "/students-credits-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/student_credit/StudentCredit"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_students_credits_report"),
  },
  {
    name: "student-balance-report-with-installments",
    path: "/student-balance-report-with-installments",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/student_balance/StudentBalanceWithInstallments"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_student_balance_report_with_installments"),
  },
  {
    name: "organizations",
    path: "/organizations",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/organizations/OrganizationList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "daily-collection-report",
    path: "/DailyCollection",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/daily_collection/DailyCollection"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_daily_collection_reports"),
  },
  {
    name: "kent-transactions-report",
    path: "/knet-transactions-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/daily_collection/KnetTransactionCollection"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "ecommerce-daily-collection-report",
    path: "/ecommerce-daily-collection",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/daily_collection/DailyCollection"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_report"),
  },
  {
    name: "withdrawal",
    path: "/invoices/report/withdrawal",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/Withdrawal"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_report"),
  },
  {
    name: "daily-credit-report",
    path: "/invoices/report/DailyCredit",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/DailyCreditV1"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_reports"),
  },
  {
    name: "parents-refund-report",
    path: "/invoices/report/parents-refund",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/DailyCreditV2"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_reports"),
  },
  {
    name: "student_invoice_report",
    path: "/invoices/report/Student",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/student/Index"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_reports"),
  },
  {
    name: "re-enrollment-report",
    path: "/re-enrollment-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/registration_reports/re_enrollment_student/ReEnrollmentReport"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_re_enrollment_report"),
  },
  {
    name: "billing-re-enrollment-report",
    path: "/billing-re-enrollment-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/ReEnrollmentReport"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "students-by-class-report",
    path: "/invoices/report/monthly",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/InvoiceMonthly"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "invoice_method_user",
    path: "/invoices/report/user-method",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/InvoiceMethodUser"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Orphan Students Report",
    path: "orphan-student-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/registration_reports/student_orphan/studentOrphanReport"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_orphan_students_report"),
  },
  {
    name: "student_exception",
    path: "students/report/student-exception",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/studentExceptionReport"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "bifurcation_students",
    path: "/bifurcation-students",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registrations/registrations" */ "@views/registrations/bifurcation/StudentList"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    name: "educational_state_report",
    path: "/educational-state-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/registration_reports/educational_state/EducationalState"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_educational_state_report"),
  },
  {
    name: "educational_state_report_enhanced",
    path: "/educational-state-report-enhanced",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/registration_reports_enhanced/educational_state/EducationalState"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "new_students",
    path: "/new-students-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/admissions/new_students/Index"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_new_students_admission_report"),
  },
  {
    name: "school-profile",
    path: "/school-profile",
    component: () =>
      import(
        /* webpackChunkName: "chunks/schools" */ "@views/schools/SchoolProfile"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "pay-print",
    path: "/invoices/report/pay-print",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/pay_print/Index"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "parent_logs_report",
    path: "/parent-logs-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/registration_reports/parent_logs/ParentLog"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_parent_logs_report"),
  },
  {
    name: "students-enrollments-report",
    path: "/students-enrollments-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/student_enrollment/StudentList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_students_enrollments_report"),
  },
  {
    name: "revenue-report",
    path: "/revenue-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/total_revenue/StudentList"
      ),

    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "statement-receivables-report",
    path: "/statement-receivables-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/statementReceivables/StageList.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_report"),
  },

  {
    name: "sport-cloth-invoices",
    path: "/sport-cloth-invoices/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/sport_cloth_invoices/ClothesInvoicesList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "unenrollment_students",
    path: "/unenrollment-students",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registered_students" */ "@views/unenrollment_students/StudentList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard(["view_un_enrollment_students_report", 'view_un_enrollment_register_students_report']),
  },
  {
    name: "billing_unenrollment_students",
    path: "/billing-un-enrollment-students",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/un_enrollment_students/StudentList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_un_enrollment_students_report"),
  },
  {
    name: "zatca-invoice-log-report",
    path: "/zatca-invoice-log-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/zatca_invoice_log/LogsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_z_a_t_c_a_invoice_log_report"),
  },

  {
    name: "notifications-sms",
    path: "/notifications/sms",
    component: () =>
      import(
        /* webpackChunkName: "chunks/notifications" */ "@views/notifications/sms/SMSList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "/student/sms-histories",
    path: "/student/sms-histories/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/students/sms_messages" */ "@views/students/sms_messages/MessagesList"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    name: "contact-messages",
    path: "/contact-messages",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/contact_messages/index"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_contact_message"),
  },
  {
    name: "create-roles",
    path: "/roles/create",
    component: () =>
      import(
        /* webpackChunkName: "chunks/roles" */ "@views/roles/NewRoleForms"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("add_role"),
  },
  {
    name: "show-roles",
    path: "/roles/show/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/roles" */ "@views/roles/ShowRoleForm"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("add_role"),
  },
  {
    name: "terms",
    path: "/terms",
    component: () =>
      import(
        /* webpackChunkName: "chunks/administrative-regions" */ "@views/terms/TermsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("add_terms_and_condition"),
  },
  {
    name: "school-facilities",
    path: "school-facilities",
    component: () =>
      import(
        /* webpackChunkName: "chunks/website/web_school_level/details/school_facility" */ "@views/website/web_school_level/details/school_facility/SchoolFacilityList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "website-about-school",
    path: "/website-about-school",
    component: () =>
      import(
        /* webpackChunkName: "chunks/website/web_school_about" */ "@views/website/web_school_about/AboutList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    //for test
    name: "organization-refunds",
    path: "/organization-refunds/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/organizations/refunds" */ "@views/organizations/transactions/RefundsList"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    name: "website-school-sliders",
    path: "/website-school-sliders",
    component: () =>
      import(
        /* webpackChunkName: "chunks/website/web_school_slider" */ "@views/website/web_school_slider/WebSchoolSliderList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "cancellation-policy",
    path: "/cancellation-policy/:academic_year_id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/cancellation_policy/CancellationPolicyList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_cancellation_policy"),
  },
  {
    name: "chronic-diseases",
    path: "/chronic-diseases",
    component: () =>
      import(
        /* webpackChunkName: "chunks/chronic_diseases" */ "@views/chronic_diseases/ChronicDiseasesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_chronic_disease"),
  },
  {
    name: "administrative_boards",
    path: "administrative-boards",
    component: () =>
      import(
        /* webpackChunkName: "chunks/website/web_school_level/details/administrative_board" */ "@views/website/web_school_level/details/administrative_board/AdministrativeBoardList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "website-contacts",
    path: "/website-contacts",
    component: () =>
      import(
        /* webpackChunkName: "chunks/website/web_contacts" */ "@views/website/web_contacts/WebContactList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "discount-report",
    path: "/invoices/report/discount",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/Discount"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_reports"),
  },
  {
    name: "school-activities",
    path: "school-activities",
    component: () =>
      import(
        /* webpackChunkName: "chunks/website/web_school_level/details/school_activity" */ "@views/website/web_school_level/details/school_activity/SchoolActivityList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "user-profile",
    path: "/user/profile",
    component: () =>
      import(/* webpackChunkName: "chunks/schools" */ "@views/users/Profile"),
  },
  {
    name: "stage-balance-report",
    path: "/invoices/report/stage-balance-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/stage_balance/StageBalance"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_reports"),
  },
  {
    name: "website-school-services",
    path: "/website-school-services",
    component: () =>
      import(
        /* webpackChunkName: "chunks/website/web_school_services" */ "@views/website/web_school_services/WebSchoolServiceList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "ecommerce-categories",
    path: "/ecommerce-categories",
    component: () =>
      import(
        /* webpackChunkName: "chunks/ecommerce/categories" */ "@views/ecommerce/categories/CategoriesList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "students-dues-report",
    path: "/invoices/report/students-total-dues",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/StudentsTotalDues"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_reports"),
  },
  {
    name: "ecommerce-item-logs",
    path: "/ecommerce-item-logs/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/ecommerce/Items/ItemLogs" */ "@views/ecommerce/Items/ItemLogs/LogsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "year-level-class-balance-report",
    path: "/invoices/report/year-level-class-balance-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/year_level_class_balance/YearLevelClassBalance"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_reports"),
  },
  {
    name: "withdrawal-requests",
    path: "/withdrawal-requests",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/withdrawal_requests/WithdrawalRequestsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "prev-school-types",
    path: "/prev-school-types",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/prev_school_types/PrevSchoolTypesList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_prev_school_type"),
  },
  {
    name: "ecommerce-add-order",
    path: "/ecommerce-add-order",
    component: () =>
      import(
        /* webpackChunkName: "chunks/ecommerce/orders" */ "@views/ecommerce/orders/OrderCreate"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "website-school-pages",
    path: "/website-school-pages",
    component: () =>
      import(
        /* webpackChunkName: "chunks/website/web_school_page" */ "@views/website/web_school_page/WebSchoolPageList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "exception_requests",
    path: "/exception-requests",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard/exception_requests" */ "@views/exception_requests/ExceptionRequestList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "installment-transactions",
    path: "/organization-transactions/installments/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/organizations/transactions/installments" */ "@views/organizations/transactions/InstallmentList"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    name: "tax-settings",
    path: "/tax-settings",
    component: () =>
      import(
        /* webpackChunkName: "chunks/tax-settings" */ "@views/tax_settings/TaxList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_tax_management"),
  },
  {
    name: "student-report",
    path: "/invoices/report/Student",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/student/Index"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_reports"),
  },
  {
    name: "ecommerce-edit-item",
    path: "/ecommerce-item/edit/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/ecommerce/Items" */ "@views/ecommerce/Items/ItemEdit"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "customers",
    path: "/customers",
    component: () =>
      import(
        /* webpackChunkName: "chunks/ecommerce/Customers" */ "@views/ecommerce/Customers/CustomerList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "website-school-jobs/applications",
    path: "website-school-jobs/applications/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/website/web_school_job/applications" */ "@views/website/web_school_job/applications/ApplicationsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "website-events",
    path: "/website-events",
    component: () =>
      import(
        /* webpackChunkName: "chunks/website/web_school_event" */ "@views/website/web_school_event/WebSchoolEventList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "organization-transactions",
    path: "/organization-transactions/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/organizations/transactions" */ "@views/organizations/transactions/TransactionList"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    //for test
    name: "organization-debits",
    path: "/organization-debits/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/organizations/debits" */ "@views/organizations/transactions/DebitList"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    name: "refund-report",
    path: "/invoices/report/refund",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/Refund"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_reports"),
  },
  {
    name: "registration-new-students-report",
    path: "/registration-new-students-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/registration_reports/new_students/StudentsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_new_students_registration_report"),
  },
  {
    name: "grade_book_set_up",
    path: "/grade_book_set_up",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/grade_book_grades/GradeBooksList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_gradebook_grade"),
  },
  {
    name: "website-school-levels",
    path: "/website-school-levels",
    component: () =>
      import(
        /* webpackChunkName: "chunks/website/web_school_level" */ "@views/website/web_school_level/WebSchoolLevelList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "stage_student_type_report",
    path: "stage-student-type-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/registration_reports/StageStudentType"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "add-transaction",
    path: "/organization-transactions/add-transaction/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/organizations/transactions/rv_accounts" */ "@views/organizations/transactions/rv_accounts/AddTransactionForm"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    // @views/registration_reports/not_enrollment_students/StudentsList
    name: "not-enrollment-students-report",
    path: "/not-enrollment-students-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/registration_reports/not_enrollment_students/StudentList.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "total_income_per_user",
    path: "/invoices/report/total-income-per-user",
    component: () =>
      import(
        /* webpackChunkName: "chunks/registration" */ "@views/billing_reports/TotalIncomePerUser.vue"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_total_income_per_user"),
  },
  {
    name: "ecommerce-view-item",
    path: "/ecommerce-item/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/ecommerce/Items" */ "@views/ecommerce/Items/ItemView"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "man-teachers",
    path: "/man-teachers",
    component: () =>
      import(
        /* webpackChunkName: "chunks/teachers" */ "@views/teachers/TeachersList1"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "documents-print",
    path: "/invoices/report/documents-print",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/documents_print/Index"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_reports"),
  },
  {
    name: "parents-balance-report",
    path: "/parents-balance-report",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/parents_balance/ParentBalanceList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_analytical_parent_balance_report"),
  },
  {
    name: "enrolled_students",
    path: "/enrolled-students",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/students_enrolled/StudentsList"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_enrolled_students"),
  },
  {
    name: "ecommerce-items",
    path: "/ecommerce-items",
    component: () =>
      import(
        /* webpackChunkName: "chunks/ecommerce/Items" */ "@views/ecommerce/Items/ItemsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "add_rv",
    path: "/organization-transactions/add-rv/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/organizations/transactions/rv_accounts" */ "@views/organizations/transactions/rv_accounts/RvForm"
      ),
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    name: "financial-increase-report",
    path: "/invoices/report/RefundReport",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/RefundRepo"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_report"),
  },
  {
    name: "ecommerce-add-item",
    path: "/ecommerce-add-item",
    component: () =>
      import(
        /* webpackChunkName: "chunks/ecommerce/Items" */ "@views/ecommerce/Items/ItemCreate"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "website-event-types",
    path: "/website-event-types",
    component: () =>
      import(
        /* webpackChunkName: "chunks/website/web_school_event_type" */ "@views/website/web_school_event_type/WebSchoolEventTypeList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "delayed-invoices-report",
    path: "/invoices/report/Delayed",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/DelayedInvoices"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_reports"),
  },
  {
    name: "orders",
    path: "/orders",
    component: () =>
      import(
        /* webpackChunkName: "chunks/ecommerce/orders" */ "@views/ecommerce/orders/OrdersList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "re-enrollment-requests",
    path: "/re-enrollment-requests",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/enrollment_requests/StudentsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "calendars",
    path: "/calendars",
    component: () =>
      import(
        /* webpackChunkName: "chunks/calendars" */ "@views/calendars/CalendarsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "website-school-advertise",
    path: "/website-school-advertise",
    component: () =>
      import(
        /* webpackChunkName: "chunks/website/web_school_advertise" */ "@views/website/web_school_advertise/WebSchoolAdvertiseList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "whatsapp-settings",
    path: "/whatsapp-settings",
    component: () =>
      import(
        /* webpackChunkName: "chunks/chronic_diseases" */ "@views/settings/WhatsApp"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("add_whatsapp_setting_whats_app_setting"),
  },
  {
    name: "ecommerce-view-order",
    path: "/ecommerce-view-order/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/ecommerce/orders" */ "@views/ecommerce/orders/OrderView"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "parent-report",
    path: "/invoices/report/Parent",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/Parent"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_reports"),
  },
  {
    name: "parents-payments",
    path: "/invoices/report/ParentsPayments",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/ParentsPayments"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_reports"),
  },
  {
    name: "certificate-reservation-funds-report",
    path: "/invoices/report/certificate-reservation-funds",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/CertificateReservation"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_reports"),
  },
  {
    name: "passport-types",
    path: "/passport-types",
    component: () =>
      import(
        /* webpackChunkName: "chunks/passport_types" */ "@views/passport_types/PassportTypeList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "website-school-levels/details",
    path: "website-school-levels/details/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/website/web_school_level/details" */ "@views/website/web_school_level/details/DetailsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "website-school-jobs",
    path: "/website-school-jobs",
    component: () =>
      import(
        /* webpackChunkName: "chunks/website/web_school_job" */ "@views/website/web_school_job/WebSchoolJobList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "certificate-reservation-report",
    path: "/invoices/report/certificate-reservation",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/CertificateReservation"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_reports"),
  },
  {
    name: "birth-places",
    path: "/birth-places",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/birth_places/BirthPlacesList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "funded_balance-report",
    path: "/invoices/report/funded_balance",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/FundedBalance"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_reports"),
  },
  {
    name: "website-school-gallery",
    path: "/website-school-gallery",
    component: () =>
      import(
        /* webpackChunkName: "chunks/website/web_school_gallery" */ "@views/website/web_school_gallery/WebSchoolGalleryList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "stages-dues-report",
    path: "/invoices/report/stages-total-dues",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/billing_reports/StagesTotalDues"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_other_financial_reports"),
  },
  {
    name: "ib-settings",
    path: "/ib/settings",
    component: () =>
      import(
        /* webpackChunkName: "chunks/ib-settings" */ "@views/admin/ib/Index"
      ),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: canAccessGuard("view_ib_settings")
  },
];
